<template>
  <div
    class="faq-card bg-white border border-gray-3 !mb-2.5"
    :class="{ 'bg-gradient-to-r from-white to-[#deebf2]': isExpanded }"
    @click="toggleExpandHandle"
  >
    <!-- :style="{
      backgroundImage: isExpanded
        ? 'linear-gradient(to right, white, #deebf2)'
        : 'white',
    }" -->
    <div class="card-body">
      <h3
        class="text-[18px] text-mobile-heading-4 md:text-heading-4 text-primary-1 max-md:w-[240px]"
      >
        {{ t(question) }}
      </h3>
      <button
        v-if="iconType == 'chevron'"
        class="expand-btn w-[34px] h-[34px]"
        aria-label="faq chevron"
        :class="isExpanded ? '-rotate-90' : 'rotate-90'"
      >
        <IconFaqArrow class="icon text-[20px] text-primary-2" />
      </button>

      <slot />
    </div>
    <transition name="collapse">
      <div v-if="isExpanded" class="text-gray-1">
        <div class="mt-[30px] text-mobile-paragraph-1 md:text-paragraph-1">
          {{ t(answer) }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script setup lang="ts">
import { ref } from "vue";
const { t } = useI18n();

defineProps({
  question: {
    type: String,
    required: true,
  },
  answer: {
    type: String,
    required: true,
  },
  iconType: {
    type: String,
    default: "chevron",
  },
});
const isExpanded = ref(false);
function toggleExpandHandle() {
  isExpanded.value = !isExpanded.value;
}
</script>
